import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

interface CustomHeaderProps {
  title: string;
  description: string;
}

const CustomHeader: FC<CustomHeaderProps> = ({ title, description }) => (
  <Helmet>
    <title>{title}</title>
    <meta key="title" name="title" content={title} data-rh="true" />
    <meta key="description" name="description" content={description} data-rh="true" />
  </Helmet>
);

export default CustomHeader;
